// Shared buyer-returns empty state (screens-buyer-app §23). One presentational
// component reused across the hub tabs, the order picker, and detail.
// No emoji — the spec's mailbox glyph maps to a Phosphor icon.
import { Box, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { TrayIcon, type Icon } from "@phosphor-icons/react";

export interface ReturnEmptyStateProps {
  title: string;
  description?: string;
  /** Phosphor icon component; defaults to a tray (inbox) glyph. */
  icon?: Icon;
  /** Optional primary CTA. */
  actionLabel?: string;
  onAction?: () => void;
}

export function ReturnEmptyState({
  title,
  description,
  icon: IconCmp = TrayIcon,
  actionLabel,
  onAction,
}: ReturnEmptyStateProps) {
  return (
    <Box py={48} px="md">
      <Stack align="center" gap="md" maw={460} mx="auto">
        <ThemeIcon size={64} radius="xl" variant="light" color="gray">
          <IconCmp size={36} weight="duotone" />
        </ThemeIcon>
        <Title order={4} ta="center">
          {title}
        </Title>
        {description ? (
          <Text size="sm" c="dimmed" ta="center">
            {description}
          </Text>
        ) : null}
        {actionLabel && onAction ? (
          <Button variant="light" color="brand" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
}
